export const srcSetGenerator = (url: string, width: number, height: number): string =>
  `${url}?fm=webp&w=${Math.round(width / 2)}&h=${Math.round(height / 2)} 1x,${url}?fm=webp&w=${width}&h=${height} 2x`;
